import { Box, Grid } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import ClientContactsTable from './dataTables/clientContactsTable.component';

import ClientOverviewTable from './dataTables/clientOverviewTable.component';
import PropTypes from 'prop-types';
import React from 'react';
import TRCTeamTable from './dataTables/trcTeamTable.component';
import AddressesCard from './dataTables/clientAddressesCard.component';
import ClientDivisionsTable from './dataTables/clientDivisionsTable.component';
import ClientPreferredVendors from './clientVendorPreferredCard.component';
import RecentCommentsCard from './dataTables/recentCommentsCard.component';
import SalesCard from './dataTables/salesCard.component';

const GeneralInfoTab = ({ formikProps, clientDetails, enumerations, vendors, internalUsers, history }) => {
 
  const provinceEnums = enumerations && enumerations.allEnums ? enumerations.allEnums.provinces : [];

  return (
    <Box sx={{ padding: '20px' }}>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} md={8} rowSpacing={2}>
          <ClientOverviewTable clientDetails={clientDetails.clientDetails} enumerations={enumerations.allEnums} vendors={vendors} history={history} />
          <Box sx={{ paddingTop: '16px' }}>
            <AddressesCard
              clientId={clientDetails.clientDetails.clientRecordId}
              clientAddresses={clientDetails.clientAddresses}
              enumerations={enumerations.allEnums}
            />
          </Box>
          {clientDetails && clientDetails.clientContacts && (
            <Box sx={{ paddingTop: '16px' }}>
              <ClientContactsTable
                clientRecordId={clientDetails.clientDetails.clientRecordId}
                clientDivisions={clientDetails.clientDivisions}
                clientContacts={clientDetails.clientContacts}
                enumerations={enumerations.allEnums}
                vendors={vendors}
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={12} md={4} rowSpacing={2}>
          <TRCTeamTable clientDetails={clientDetails.clientDetails} enumerations={enumerations} internalUsers={internalUsers} />
          <Box sx={{ paddingTop: '16px' }}>
            <ClientDivisionsTable
              clientRecordId={clientDetails.clientDetails.clientRecordId}
              clientDetails={clientDetails.clientDetails}
              clientDivisions={clientDetails.clientDivisions}
              enumerations={enumerations.allEnums}
              clientAddresses={clientDetails.clientAddresses}
              provinceEnums={provinceEnums}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <SalesCard
              clientDetails={clientDetails.clientDetails}
              internalUsers={internalUsers}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <RecentCommentsCard
              clientId={clientDetails.clientDetails.clientRecordId}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <ClientPreferredVendors
              clientVendorRelationships={clientDetails.clientVendorRelationships}
              clientId={clientDetails.clientDetails.clientRecordId}
              vendors={vendors}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

GeneralInfoTab.propTypes = {
  formikProps: PropTypes.object.isRequired,
  clientDetails: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { clientDetails } = state.clients.clientsInfo[state.clients.currentClientId];
  return {
    clientDetails
  };
};

export default compose(connect(mapStateToProps))(GeneralInfoTab);
